/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ComponentRef, inject, Type, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { LoggerService } from '../../shared/services/logger.service';
import { MapCommandAttributes, MapCommandMenuItem } from '../types';

export abstract class MapCommand {
    shouldDisplay$: Observable<boolean> = of(true);
    shouldDisable$: Observable<boolean> = of(false);
    menuItems$: Observable<MapCommandMenuItem[]> = of([]);
    deactivate$: Subject<void> = new Subject<void>();
    // triggered when deactivated by external action
    deactivated$ = new Subject<void>();
    customLabel$ = new BehaviorSubject<string>(null);
    preventClose$ = new BehaviorSubject<boolean>(false);

    protected deps: { [k: string]: any };
    protected attributes: MapCommandAttributes = {};

    abstract invoke(): void;

    setDependencies(deps: { [k: string]: any }) {
        this.deps = deps;
        this.deps['logger'] = inject(LoggerService);
        this.onCommandInit();
    }

    setAttributes(attributes: MapCommandAttributes) {
        this.attributes = attributes;
        this.onAttributesSet();
    }

    hasCustomUi(): boolean {
        return false;
    }

    getCustomUiType(): Type<any> {
        return null;
    }

    createCustomUi<T>(view: ViewContainerRef, type: Type<T>): ComponentRef<T> {
        return view.createComponent<T>(type);
    }

    protected onCommandInit() {}
    protected onAttributesSet() {}
}
